import { GSTN_INFO_DATA, HISTORY_TABLE_TOTAL_PAGES, LOADER_STATUS } from "./constants";

export const initialState = {
    loaderStatus: false,  
    gstnInfoData: [],
    historyTablePages: 1,
};
  
  /* eslint-disable default-case, no-param-reassign */
  const gstr6ISDDetailsReducer = (state = initialState, action) =>{
      switch (action.type) {
        
        case LOADER_STATUS:
          return {
            ...state,
            loaderStatus:action.loaderStatus
          }
        case GSTN_INFO_DATA:
          return {
            ...state,
            gstnInfoData:action.data
          }
        case HISTORY_TABLE_TOTAL_PAGES:
          return {
            ...state,
            historyTablePages:action.pages
          }
        
        default:
          return state;
      }
    };
  
  export default gstr6ISDDetailsReducer;